import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken, notifyAuthFailure } from "src/auth/auth-client";

import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: `${__MSS_API_BASE_URL__}/api/`,
  prepareHeaders: async (headers) => {
    if (__MSS_AUTH_DISABLED__) {
      return headers;
    }

    try {
      const token = await getAccessToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    } catch (e) {
      console.error("[auth] baseQuery: ", e);
      throw e;
    }
  },
});

const baseQueryWithAuthFailure: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    notifyAuthFailure();
  }
  return result;
};

export const Api = createApi({
  reducerPath: "Api",
  baseQuery: baseQueryWithAuthFailure,
  keepUnusedDataFor: 30,
  tagTypes: [
    "character-style-records",
    "paragraphs",
    "style-profiles",
    "paragraph-style-records",
    "tracked-changes",
  ],
  endpoints: () => ({}),
});
